import React__default, { useContext } from 'react';
import { g as getChannelTitle } from '../../utils-b571dc44.js';
import { L as Label, a as LabelTypography, b as LabelColors } from '../../index-6420013c.js';
import Icon, { IconColors, IconTypes } from '../../ui/Icon.js';
import IconButton from '../../ui/IconButton.js';
import ChannelAvatar from '../../ui/ChannelAvatar.js';
import { a as LocalizationContext } from '../../LocalizationContext-a82461b5.js';
import useSendbirdStateContext from '../../useSendbirdStateContext.js';
import { u as useChannelContext } from '../../ChannelProvider-5dcbee7b.js';
import { u as useMediaQueryContext } from '../../MediaQueryContext-d6110905.js';
import { n as noop } from '../../utils-e0c7329c.js';
import 'prop-types';
import '../../stringSet-b60e9529.js';
import '../../_rollupPluginBabelHelpers-05128ded.js';
import '../../ui/Avatar.js';
import '../../ui/ImageRenderer.js';
import '../../uuid-717930b4.js';
import '../../utils-7f5e872b.js';
import '../../index-6add7940.js';
import '../../withSendbird.js';
import '../../UserProfileContext-f3f446d2.js';
import '../../const-72f012b6.js';
import '../../index-ccef08fe.js';
import '../../topics-eb548880.js';
import '../../index-579ca9d7.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../compareIds-2e50e905.js';
import '@sendbird/chat/groupChannel';
import '@sendbird/chat/message';
import '../../consts-fa6ab3c0.js';
import '../../resolvedReplyType-9d00a3db.js';
var ChannelHeader = function ChannelHeader(_ref) {
  var _globalStore$config, _globalStore$config2, _currentGroupChannel$;
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var globalStore = useSendbirdStateContext();
  var userId = globalStore === null || globalStore === void 0 ? void 0 : (_globalStore$config = globalStore.config) === null || _globalStore$config === void 0 ? void 0 : _globalStore$config.userId;
  var theme = globalStore === null || globalStore === void 0 ? void 0 : (_globalStore$config2 = globalStore.config) === null || _globalStore$config2 === void 0 ? void 0 : _globalStore$config2.theme;
  var channelStore = useChannelContext();
  var _useMediaQueryContext = useMediaQueryContext(),
    isMobile = _useMediaQueryContext.isMobile;
  var currentGroupChannel = channelStore.currentGroupChannel,
    showSearchIcon = channelStore.showSearchIcon,
    onSearchClick = channelStore.onSearchClick,
    onChatHeaderActionClick = channelStore.onChatHeaderActionClick,
    _channelStore$onBackC = channelStore.onBackClick,
    onBackClick = _channelStore$onBackC === void 0 ? noop : _channelStore$onBackC;
  var subTitle = (currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.members) && (currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : (_currentGroupChannel$ = currentGroupChannel.members) === null || _currentGroupChannel$ === void 0 ? void 0 : _currentGroupChannel$.length) !== 2;
  var isMuted = (currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.myMutedState) === 'muted';
  var _useContext = useContext(LocalizationContext),
    stringSet = _useContext.stringSet;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-chat-header ".concat(className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-chat-header__left"
  }, isMobile && /*#__PURE__*/React__default.createElement(Icon, {
    className: "sendbird-chat-header__icon_back",
    onClick: onBackClick,
    fillColor: IconColors.PRIMARY,
    width: "24px",
    height: "24px",
    type: IconTypes.ARROW_LEFT
  }), /*#__PURE__*/React__default.createElement(ChannelAvatar, {
    theme: theme,
    channel: currentGroupChannel,
    userId: userId,
    height: 32,
    width: 32
  }), /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird-chat-header__left__title",
    type: LabelTypography.H_2,
    color: LabelColors.ONBACKGROUND_1
  }, getChannelTitle(currentGroupChannel, userId, stringSet)), /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird-chat-header__left__subtitle",
    type: LabelTypography.BODY_1,
    color: LabelColors.ONBACKGROUND_2
  }, subTitle)), /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-chat-header__right"
  }, (typeof isMuted === 'string' && isMuted === 'true' || typeof isMuted === 'boolean' && isMuted) && /*#__PURE__*/React__default.createElement(Icon, {
    className: "sendbird-chat-header__right__mute",
    type: IconTypes.NOTIFICATIONS_OFF_FILLED,
    fillColor: IconColors.ON_BACKGROUND_2,
    width: "24px",
    height: "24px"
  }), showSearchIcon && !(currentGroupChannel !== null && currentGroupChannel !== void 0 && currentGroupChannel.isEphemeral) && /*#__PURE__*/React__default.createElement(IconButton, {
    className: "sendbird-chat-header__right__search",
    width: "32px",
    height: "32px",
    onClick: onSearchClick
  }, /*#__PURE__*/React__default.createElement(Icon, {
    type: IconTypes.SEARCH,
    fillColor: IconColors.PRIMARY,
    width: "24px",
    height: "24px"
  })), /*#__PURE__*/React__default.createElement(IconButton, {
    className: "sendbird-chat-header__right__info",
    width: "32px",
    height: "32px",
    onClick: onChatHeaderActionClick
  }, /*#__PURE__*/React__default.createElement(Icon, {
    type: IconTypes.INFO,
    fillColor: IconColors.PRIMARY,
    width: "24px",
    height: "24px"
  }))));
};
export { ChannelHeader as default };